import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { getStockTemplateDetails } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";
import { LoadingSmall } from "@/components/LoadingSmall";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTemplate } from "@/store/templateEditor/templateEditorSlice";
import { selectActiveFirm } from "@/store/appSelectors";
import { selectCurrentTemplate } from "@/store/templateEditor/templateEditorSelectors";
import { convertToTemplate } from "@/pages/template/utils/templateUtils";
import { TemplateStockEditor } from "./TemplateStockEditor";

export const TemplateStockEditorPage = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const id = String(searchParams.get("Id"));
  const activeFirm = useSelector(selectActiveFirm);
  const currentTemplate = useSelector(selectCurrentTemplate);

  const { data, isLoading } = useQuery({
    queryKey: ["stockTemplateDetails", id],
    queryFn: () => getStockTemplateDetails(String(activeFirm?.firmGuid), id),
    refetchOnMount: true,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

  const templateResponse = data?.data;

  useEffect(() => {
    if (templateResponse) {
      dispatch(setCurrentTemplate(convertToTemplate(templateResponse)));
    }
  }, [templateResponse, dispatch]);

  if (isLoading)
    return (
      <div className="p-4">
        <LoadingSmall />
      </div>
    );
  if (!currentTemplate) return <div className="flex justify-center items-center h-screen">Template not found</div>;

  return <TemplateStockEditor template={currentTemplate} />;
};
